import { render, staticRenderFns } from "./oditem.vue?vue&type=template&id=6ba70c4d&scoped=true&"
import script from "./oditem.vue?vue&type=script&lang=js&"
export * from "./oditem.vue?vue&type=script&lang=js&"
import style0 from "./oditem.vue?vue&type=style&index=0&id=6ba70c4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba70c4d",
  null
  
)

export default component.exports